import React from 'react'
import {
  CartesianGrid,
  Legend,
  LineChart,
  ResponsiveContainer,
  XAxis,
  YAxis,
  Tooltip,
  Line,
} from 'recharts'

const UsageGraph = ({ data, users, orgs, hideAll }) => {
  if (!data.length) return <div>No data</div>

  const colors = ['#8884d8', '#82ca9d', '#ffc658', '#ff7300', '#a4de6c']
  const keys = Object.keys(data[0]).filter((key) => key !== 'all' && key !== 'reference')

  return (
    <ResponsiveContainer width="100%" height={400}>
      <LineChart data={data} margin={{ top: 5, right: 30, left: 20, bottom: 5 }}>
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="reference" angle={-45} textAnchor="end" height={70} interval={0} />
        <YAxis
          label={{
            value: 'Actions Count',
            angle: -90,
            position: 'insideLeft',
          }}
          interval={0}
        />
        <Tooltip />
        <Legend />
        <If condition={!hideAll}>
          <Line type="monotone" dataKey="all" stroke="#000000" activeDot={{ r: 8 }} name="All" />
        </If>
        {keys.map((key, index) => (
          <Line
            key={key}
            type="monotone"
            dataKey={key}
            stroke={colors[index % colors.length]}
            activeDot={{ r: 8 }}
            name={orgs?.find((f) => f.value === key)?.label || users?.[key] || key}
          />
        ))}
      </LineChart>
    </ResponsiveContainer>
  )
}

export default UsageGraph
